import React, { Component } from 'react';
// import firebase from 'firebase/app';
// import 'firebase/auth';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import { emailValidator } from '../helpers/validators';

import { SoundwiseHeader } from './soundwise_header';
import Footer from './footer';

const styles = {
  button: {
    backgroundColor: '#F76B1C',
  },
  buttonDisabled: {
    backgroundColor: 'gray',
  },
  headerText: {
    color: '#F76B1C',
  },
  error: {
    color: 'red',
  },
};

import parseQueryParams from '../helpers/parseQueryParams';

export default class PassRecovery extends Component {
  constructor(props) {
    super(props);

    const queryParams = getPath(props, 'location.search');
    const params = parseQueryParams(queryParams);
    const { publisher: publisherId = '' } = params || {};
    console.log(`***** 3`, publisherId);
  
    this.state = {
      email: '',
      submitted: false,
      error: '',
      loader: false,
      publisherId,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleSubmit() {
    const { email, publisherId } = this.state;
    const that = this;
    const setStateSubmitted = () => {
      that.setState({
        submitted: true,
        loader: false,
      }); 
    };
    const setStateError = (errorMessage) => {
      that.setState({
        error: [
          'Failed to send password reset email.',
          <br key='err_br' />,
          ...errorMessage,
        ],
        loader: false,
      });
    };

    that.setState({
      error: '',
      loader: true,
    }, () => {
      if (isEmpty(email)) {
        return setTimeout(() => setStateError(['Email is missing.']), 500);
      }
      if (!emailValidator(email)) {
        return setTimeout(() => setStateError(['Invalid Email address.']), 500);
      }

      // firebase.auth().sendPasswordResetEmail(email).then(
      //   function() {
      //     that.setState({
      //       submitted: true,
      //       loader: false,
      //     });
      //   },
      //   function(error) {
      //     that.setState({
      //       error: 'Failed to send password reset email. Did you enter a valid email?',
      //       loader: false,
      //     });
      //   }
      // );
      Axios.post('api/user/password_reset', { 
        email,
        ...(isEmpty(publisherId) ? {} : { publisherId }),
      })
        .then(res => setStateSubmitted())
        .catch(err => {
          let errorMessage = [ 'Did you enter a valid email?' ];
          if( !isEmpty(err.response) && !isEmpty(err.response.data) ){
            const { success = false, statusCode = 0, message = '' } = err.response.data || {};
            if (!success && !isEmpty(message)) {
              if (message.includes('RESET_PASSWORD_EXCEED_LIMIT')) {
                errorMessage = [
                  'The number of attempts has been exhausted.', <br key='err_br2' />,
                  'Please try later.',
                ];
              } else if (statusCode < 500) {
                errorMessage = [ message ];
              }
            }
          }
          setStateError( errorMessage );
        });
    });
  }

  render() {
    if (this.state.submitted) {
      return (
        <div>
          {isEmpty(this.state.publisherId) && <SoundwiseHeader showIcon={true} />}
          <section
            className="padding-110px-tb bg-white builder-bg xs-padding-60px-tb"
            id="feature-section14"
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                  <h2 className="section-title-large sm-section-title-medium xs-section-title-large text-dark-gray font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text">
                    PASSWORD RESET EMAIL SENT
                  </h2>
                </div>
              </div>
            </div>
          </section>
          {isEmpty(this.state.publisherId) && <Footer />}
        </div>
      );
    } else {
      return (
        <div>
          {isEmpty(this.state.publisherId) && <SoundwiseHeader showIcon={true} />}
          <section
            className="padding-110px-tb xs-padding-60px-tb bg-white builder-bg"
            id="subscribe-section6"
          >
            <div className="container">
              <div className="row">
                <div className="col-md-8 center-col col-sm-12 text-center">
                  <h2
                    className="title-extra-large-2 alt-font xs-title-large  margin-four-bottom tz-text"
                    style={styles.headerText}
                  >
                    Forgot your password?
                  </h2>
                  <div className="text-extra-large sm-text-extra-large text-medium-gray width-80 xs-width-100 center-col margin-twelve-bottom xs-margin-nineteen-bottom tz-text">
                    If you forgot your password, please enter the email address associated with your
                    account to reset your password.
                  </div>
                </div>
                <div className="col-md-6 center-col col-sm-12 text-center">
                  <input
                    onChange={this.handleChange}
                    value={this.state.email}
                    type="email"
                    name="email"
                    id="email"
                    data-email="required"
                    placeholder="Email"
                    className="big-input bg-light-gray alt-font border-radius-4"
                  />
                  <button
                    onClick={this.handleSubmit}
                    type="submit"
                    className="contact-submit btn btn-extra-large2 propClone btn-3d text-white width-100 builder-bg tz-text"
                    disabled={this.state.loader}
                    style={this.state.loader ? styles.buttonDisabled : styles.button}
                  >
                    {this.state.loader && 'Please wait ...'}
                    {!this.state.loader && 'Send reset email'}
                  </button>
                  <div className="text-extra-large sm-text-extra-large" style={styles.error}>
                    {this.state.error}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {isEmpty(this.state.publisherId) && <Footer />}
        </div>
      );
    }
  }
}
